// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_dd-0";
export var fileCarousel = "_dd-2";
export var removeFileButton = "_dd-1";